<template>

  <main class="dark">
    <div class="columns is-gapless">
      <div class="column">
        <Header></Header>
        <!--<section class="section" id="respond" v-if="$route.params.r === 'no'">-->
        <!--<section class="section" id="respond" v-if="$route.params.r === 'later'">-->
        <section class="section" id="respond">
          <h1 class="title">Thanks for your response</h1>
          <div class="notification is-warning">
            <p>You can still quote before this job's deadline expires at <strong>Midnight</strong> on <strong>{{formattedDateDeadline}}</strong>.<br>Please refer to the original invite message in your inbox.</p>
          </div>
        </section>
        <Footer></Footer>
      </div>
    </div>
  </main>

</template>

<script>
import axios from 'axios'
import moment from 'moment'

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'respond',
  props: ['params', 'heading'],
  created () {
    this.$store.commit('storeToken', this.$route.params.t)
    // get Data
    const AuthStr = `Bearer ${this.$route.params.t}`
    axios.get(`${window.APP_CONFIG.apiServiceUrl}quoterequest/portal/request`, {headers: {Authorization: AuthStr}})
      .then(response => {
        // If request is good...
        this.$store.commit('storeData', response.data)
      })
      .catch((error) => {
        console.log('error', error)
      })
  },
  mounted () {
  },
  data () {
    return {

    }
  },
  methods: {

  },
  components: {
    Header,
    Footer
  },
  computed: {
    id () {
      return this.$store.state.token
    },
    quoteRequest () {
      return this.$store.state.data
    },
    formattedDateDeadline () {
      return moment(this.quoteRequest.dateDeadline).format('ddd MMM Do \'YY')
      // return moment(this.quoteRequest.dateDeadline).format('llll')
    }
  }
}
</script>
